/**
 * Normaliza digitação de moeda (BR com vírgula ou US com ponto) para valor canônico com ponto.
 * Ex.: "30000,01" | "30.000,01" | "30000.01" → "30000.01"
 * Retorna null se inválido.
 */
export function normalizeCurrencyInput(raw: string): string | null {
  if (raw === '') return '';

  let s = raw.trim().replace(/\s/g, '');
  s = s.replace(/^R\$\s*/i, '');
  if (!s) return '';
  if (s.startsWith('-')) return null;

  if (s.includes(',')) {
    if ((s.match(/,/g) || []).length > 1) return null;
    const [left, right = ''] = s.split(',');
    const intPart = left.replace(/\./g, '');
    if (!/^\d*$/.test(intPart) || !/^\d{0,2}$/.test(right)) return null;
    if (intPart === '' && right === '') return '';
    if (right === '' && s.endsWith(',')) {
      return intPart === '' ? '0.' : `${intPart}.`;
    }
    if (intPart === '') return `0.${right}`;
    return right === '' ? intPart : `${intPart}.${right}`;
  }

  // Apenas dígitos e no máximo um ponto decimal (até 2 casas)
  if (!/^\d*\.?\d{0,2}$/.test(s)) return null;
  return s;
}

/** Exibe o valor canônico no formato BR quando a moeda for BRL. */
export function formatCurrencyInputDisplay(value: string, currency: string = 'BRL'): string {
  if (!value) return '';
  if (currency !== 'BRL') return value;
  if (value.endsWith('.')) {
    return `${value.slice(0, -1)},`;
  }
  return value.replace('.', ',');
}
